import React from 'react'
import { Paper, Group, Box, Text, Avatar } from '@mantine/core'
import { IconCar } from '@tabler/icons-react'
import Note from '../../../../components/Note'

export type VehicleVersion = {
  brand?: { title: string; logo?: string }
  marque?: string
  modele: string
  sra_commercial: string
}

function BrandLogo(props: { vehicle: VehicleVersion }) {
  const { vehicle } = props
  if (vehicle.brand?.logo) {
    return (
      <img
        src={vehicle.brand.logo}
        alt={vehicle.brand.title}
        style={{ width: 44, height: 44, objectFit: 'contain', borderRadius: 8 }}
      />
    )
  }
  return <Avatar size={44} radius="md" color="brand" variant="light"><IconCar size={22} /></Avatar>
}

export const VehicleCard = (props: { vehicle: VehicleVersion; note: number }) => {
  const { vehicle, note } = props
  return (
    <Paper
      p="xl" radius="lg"
      style={{
        background: 'var(--mantine-color-gray-0)',
        border: '1px solid var(--mantine-color-gray-2)',
      }}
    >
      <Group justify="space-between" align="center">
        <Group gap="md">
          <BrandLogo vehicle={vehicle} />
          <Box>
            <Text size="xs" c="brand.6" tt="uppercase" fw={600} style={{ letterSpacing: '0.14em' }}>
              {vehicle.brand?.title ?? vehicle.marque}
            </Text>
            <Text size="xl" fw={700} mt={2} style={{ lineHeight: 1.15 }}>{vehicle.modele}</Text>
            <Text size="sm" c="dimmed" mt={4}>{vehicle.sra_commercial}</Text>
          </Box>
        </Group>
        <Box ta="center">
          <Text size="xs" c="dimmed" tt="uppercase" style={{ letterSpacing: '0.1em' }} mb={6}>
            Note globale
          </Text>
          <Note note={note} size="medium" />
        </Box>
      </Group>
    </Paper>
  )
}
